export const home = {
    path: '/',
    name: 'home_index',
    meta: {
        title: 'Home - iLab'
    },
    component: resolve => {
        require(['@/views/home.vue'], resolve)
    }
}

export const page404 = {
    path: '/*',
    name: 'error-404',
    meta: {
        title: '404 Page Not  Found - iLab'
    },
    component: resolve => {
        require(['@/views/error-page/404.vue'], resolve)
    }
}

export const projects = {
    path: '/projects',
    name: 'projects_index',
    meta: {
        title: 'Projects - iLab'
    },
    component: resolve => {
        require(['@/views/projects.vue'], resolve)
    }
}

export const members = {
    path: '/members',
    name: 'members_index',
    meta: {
        title: 'Members - iLab'
    },
    component: resolve => {
        require(['@/views/members.vue'], resolve)
    }
}

export const publications = {
    path: '/publications',
    name: 'publications_index',
    meta: {
        title: 'Publications - iLab'
    },
    component: resolve => {
        require(['@/views/publications.vue'], resolve)
    }
}

export const products = {
    path: '/products',
    name: 'products_index',
    meta: {
        title: 'Products - iLab'
    },
    component: resolve => {
        require(['@/views/products.vue'], resolve)
    }
}

export const albums = {
    path: '/albums',
    name: 'Photo Album',
    meta: {
        title: 'Photo Album -iLab'
    },
    component: resolve => {
        require(['@/views/albums.vue'], resolve)
    }
}

export const collaborators = {
    path: '/collaborators',
    name: 'Collaborators',
    meta: {
        title: 'Collaborators -iLab'
    },
    component: resolve => {
        require(['@/views/collaborators.vue'], resolve)
    }
}

export const news = {
    path: '/news',
    name: 'News',
    meta: {
        title: 'News -iLab'
    },
    component: resolve => {
        require(['@/views/news.vue'], resolve)
    }
}

export const newsDetail = {
    path: '/news/detail',
    name: 'NewsDetail',
    meta: {
        title: 'NewsDetail -iLab'
    },
    component: resolve => {
        require(['@/views/news/detail.vue'], resolve)
    },
    children: [
        {
            path: '10',
            name: 'NewsDetail',
            meta: {
                title: 'NewsDetail -iLab'
            },
            component: resolve => {
                require(['@/views/news/detail-10.vue'], resolve)
            }
        }
    ]
}

export const others = {
    path: '/others',
    name: 'Others',
    meta: {
        title: 'Others -iLab'
    },
    component: resolve => {
        require(['@/views/others/index.vue'], resolve)
    },
    children: [
        {
            path: 'baseline',
            name: 'Baseline',
            meta: {
                title: 'Baseline -iLab'
            },
            component: resolve => {
                require(['@/views/others/Baseline.vue'], resolve)
            }
        },
        {
            path: 'inference',
            name: 'Inference',
            meta: {
                title: 'Inference -iLab'
            },
            component: resolve => {
                require(['@/views/others/inference.vue'], resolve)
            }
        },
        {
            path: 'explicit',
            name: 'Explicit',
            meta: {
                title: 'Explicit -iLab'
            },
            component: resolve => {
                require(['@/views/others/explicit.vue'], resolve)
            }
        },
        {
            path: 'paraphrased',
            name: 'Paraphrased',
            meta: {
                title: 'Paraphrased -iLab'
            },
            component: resolve => {
                require(['@/views/others/paraphrased.vue'], resolve)
            }
        }
    ]
}

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    home,
    projects,
    members,
    publications,
    products,
    collaborators,
    albums,
    news,
    newsDetail,
    others,
    page404
]



// WEBPACK FOOTER //
// ./src/router/router.js